import { route } from '@app/Routing/helpers'

const FavoritesListController = () => import('@app/Staff/Favorites/ListController')
const FavoritesListProduct = () => import('@app/Staff/Favorites/List/Product')
const FavoritesListEquipment = () => import('@app/Staff/Favorites/List/Equipment')
const FavoritesListProductExtended = () => import('@app/Staff/Favorites/List/ProductExtended')

const MODEL = 'favorites'

const u = url => `${MODEL}${ url}`

const LIST_CONTROLLER = u('/')

const LIST_PRODUCT = 'product/'
const LIST_PRODUCT_EQUIPMENT = 'product/equipment/'
const LIST_EQUIPMENT = 'equipment/'
const LIST_CLOTHES = 'clothes/'

export const FAVORITES_PREFIX = `${MODEL}:`
const p = name => FAVORITES_PREFIX + name

export const FAVORITES_LIST_NAME = p('list')
export const FAVORITES_LIST_PRODUCT_NAME = p('list-product')
export const FAVORITES_LIST_PRODUCT_EQUIPMENT_NAME = p('list-product-equipment')
export const FAVORITES_LIST_EQUIPMENT_NAME = p('list-equipment')
export const FAVORITES_LIST_CLOTHES_NAME = p('list-clothes')

export function createRoutes() {
  return [
    route(LIST_CONTROLLER, FavoritesListController, FAVORITES_LIST_NAME, {
      redirect: u(`/${LIST_PRODUCT}`),
      children: [
        route(LIST_PRODUCT, FavoritesListProduct, FAVORITES_LIST_PRODUCT_NAME, {}),
        route(LIST_EQUIPMENT, FavoritesListEquipment, FAVORITES_LIST_EQUIPMENT_NAME, {}),
        route(LIST_PRODUCT_EQUIPMENT, FavoritesListProductExtended, FAVORITES_LIST_PRODUCT_EQUIPMENT_NAME, {
          meta: {
            catalogType: 'equipment',
          },
          props: true,
        }),
        route(LIST_CLOTHES, FavoritesListProductExtended, FAVORITES_LIST_CLOTHES_NAME, {
          meta: {
            catalogType: 'clothes',
          },
          props: true,
        }),
      ],
    }),
  ]
}
